export const AudioRecorderTranslations = {
  RECORD: {
    es: 'Grabar',
    en: 'Record',
    cat: 'Gravar',
    eus: 'Gurekin',
    pt: 'Gravar'
  },
  STOP: {
    es: 'Detener',
    en: 'Stop',
    cat: 'Parar',
    eus: 'Ezabatu',
    pt: 'Parar'
  }
};
